import PropTypes from 'prop-types';
import _ from 'lodash';
export const APPLICATION_NOTIFICATIONS_NOTIFY = 'APPLICATION_NOTIFICATIONS_NOTIFY';
export const APPLICATION_NOTIFICATIONS_CLEAR = 'APPLICATION_NOTIFICATIONS_CLEAR';
export const applicationNotificationsNotify = notification => ({
    type: APPLICATION_NOTIFICATIONS_NOTIFY,
    notification,
});
export const applicationNotificationsClear = notification => ({
    type: APPLICATION_NOTIFICATIONS_CLEAR,
    notification,
});
export const ApplicationNotificationsReduxNotifier = ({ notification, clearNotifications, notificationsContext, notifierType = 'toast', }) => {
    if (notification && !_.isEmpty(notification)) {
        notificationsContext?.[notifierType]?.open(_.cloneDeep(notification));
        clearNotifications();
    }
    return null;
};
ApplicationNotificationsReduxNotifier.propTypes = {
    notification: PropTypes.object,
    clearNotifications: PropTypes.func,
    notificationsContext: PropTypes.object,
    notifierType: PropTypes.string,
};
export const applicationNotifications = (state = {}, action) => {
    switch (action.type) {
        case APPLICATION_NOTIFICATIONS_NOTIFY:
            return {
                ...state,
                ...action.notification,
            };
        case APPLICATION_NOTIFICATIONS_CLEAR:
            return {};
        default:
            return state;
    }
};
//# sourceMappingURL=applicationNotificationsReduxUtils.js.map